import { Autocomplete, Chip, TextField } from '@mui/material';
import { isValidEmail, parseRecipients } from './EmailScheduleDraft';

interface RecipientsInputProps {
  value: string[];
  onChange: (recipients: string[]) => void;
  error?: string;
  helperText?: string;
  disabled?: boolean;
  autoFocus?: boolean;
}

export default function RecipientsInput(props: RecipientsInputProps) {
  const { value, onChange, error, helperText, disabled, autoFocus } = props;

  return (
    <Autocomplete
      multiple
      freeSolo
      disabled={disabled}
      options={[] as string[]}
      value={value}
      onChange={(_, values) => onChange(parseRecipients(values.join(',')))}
      renderTags={(values, getTagProps) =>
        values.map((recipient, index) => (
          <Chip
            {...getTagProps({ index })}
            key={recipient}
            label={recipient}
            size="small"
            color={isValidEmail(recipient) ? 'default' : 'error'}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus={autoFocus}
          label="Recipients"
          placeholder="Type an email and press Enter"
          helperText={error ?? helperText ?? 'Separate several addresses with commas'}
          error={!!error}
          variant="standard"
          onBlur={(e) => {
            const pending = (e.target as HTMLInputElement).value;
            if (pending.trim()) {
              onChange(parseRecipients([...value, pending].join(',')));
            }
          }}
        />
      )}
    />
  );
}
